import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DobryAgentAuthor} from '../../../../shared/interface/dobry-agent-blog-article';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {UserService} from "../../../../shared/services/user.service";
import {User} from "../../../../shared/interface/user";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PartnerService} from "../../../../shared/services/partner.service";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {Partner} from "../../../../shared/interface/partner";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {DobryAgentAuthorService} from "../../../../shared/services/dobry-agent-author.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-da-author-details-view',
  templateUrl: './da-author-details-view.component.html',
  styleUrls: ['./da-author-details-view.component.scss']
})
export class DaAuthorDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() author: ReplaySubject<DobryAgentAuthor>;
  @Output() modifyClicked = new EventEmitter<void>();

  userPermissions: ReplaySubject<UserPermissions>;
  authorObject?: DobryAgentAuthor;
  user24Id: string | null = null;
  userObject: User | null = null;
  partnerId: string | null = null;
  partnerObject: Partner | null = null;
  ofwcaId: string | null = null;
  ofwcaObject: Ofwca | null = null;

  constructor(
    private auth: AuthService,
    private userService: UserService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dobryAgentAuthorService: DobryAgentAuthorService,
    private router: Router
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
   this.loadAuthor();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  loadAuthor(): void {
    this.author
      .pipe(takeUntil(this.destroyed$))
      .subscribe((author: DobryAgentAuthor) => {
        this.authorObject = author;

        this.userObject = null;
        this.partnerObject = null;
        this.ofwcaObject = null;

        this.user24Id = author.user24Id ?? null;
        this.partnerId = author.agent?.partner24Id ?? null;
        this.ofwcaId = author.agent?.ofwca24Id ?? null;

        if (this.user24Id) {
          this.loadUser(this.user24Id);
        }

        if (this.partnerId) {
          this.loadPartner(this.partnerId);
        }

        if (this.ofwcaId) {
          this.loadOfwca(this.ofwcaId);
        }
      });
  }
  loadUser(user24Id: string): void {
    this.userService.get(user24Id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (user: User) => {
          if (this.user24Id !== user24Id) {
            return;
          }

          this.userObject = user;
        },
        error: (error: HttpErrorResponse) => {
          this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
            duration: 2000
          });
        }
      });
  }

  loadPartner(partnerId: string): void {
    this.partnerService.get(partnerId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (partner: Partner) => {
          if (this.partnerId !== partnerId) {
            return;
          }

          this.partnerObject = partner;
        },
        error: (error: HttpErrorResponse) => {
          this.snack.open('Nie udało się pobrać danych partnera', error.status.toString(), {
            duration: 2000
          });
        }
      });
  }

  loadOfwca(ofwcaId: string): void {
    this.ofwcaService.get(ofwcaId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (ofwca: Ofwca) => {
          if (this.ofwcaId !== ofwcaId) {
            return;
          }

          this.ofwcaObject = ofwca;
        },
        error: (error: HttpErrorResponse) => {
          this.snack.open('Nie udało się pobrać danych OFWCA', error.status.toString(), {
            duration: 2000
          });
        }
      });
  }

  delete(author: DobryAgentAuthor): void {
    this.dobryAgentAuthorService
      .confirmDelete(author)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/autorzy'
        ]);
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentAuthorService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/autorzy'
        ]);
      });
  }
}
